import type { MarketplaceLead } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DispensariesApi } from 'api/DispensariesApi';
import { DISPENSARY_MARKETPLACE_LEADS_KEY } from 'tanstack-hooks/keys';

export function useCreateDispensaryMarketplaceLead(dispensaryId: string) {
  const dispensaryApi = new DispensariesApi();
  const queryClient = useQueryClient();

  const {
    mutateAsync: createDispensaryMarketplaceLead,
    isPending: isCreateDispensaryMarketplaceLeadPending
  } = useMutation({
    mutationKey: [DISPENSARY_MARKETPLACE_LEADS_KEY],
    mutationFn: async (props: { spId: string; offerId: string; comment?: string }) =>
      await dispensaryApi.createMarketplaceLead(dispensaryId, props.spId, props.offerId, {
        comment: props.comment
      }),
    onSuccess: (createdLead) => {
      const crbMarketplaceLeads: MarketplaceLead[] | undefined = queryClient.getQueryData([
        DISPENSARY_MARKETPLACE_LEADS_KEY,
        dispensaryId
      ]);
      return queryClient.setQueryData(
        [DISPENSARY_MARKETPLACE_LEADS_KEY, dispensaryId],
        (crbMarketplaceLeads ?? []).concat(createdLead)
      );
    }
  });

  return {
    createDispensaryMarketplaceLead,
    isCreateDispensaryMarketplaceLeadPending
  };
}
